import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edge",
  "use": "icon-edge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-edge\"><path d=\"M875.946667 128v696.832H938.666667V896H85.333333v-71.168h66.816V128H875.946667z m-412.757334 522.197333h-27.093333l-78.464 174.592h27.904l-0.597333-0.298666 78.250666-174.293334z m-103.978666 0h-25.941334l-78.464 174.592h26.837334l-0.682667-0.298666 78.250667-174.293334z m206.293333 0h-25.429333l-78.464 174.592h26.026666l-0.426666-0.170666 78.293333-174.421334z m102.869333 0h-25.984l-78.421333 174.592h26.453333l-0.384-0.170666 78.336-174.421334z m103.978667 0h-27.093333l-78.421334 174.592h27.562667l-0.384-0.170666 78.336-174.421334z m33.664 96.213334l-35.2 78.378666h35.242667l-0.042667-78.378666zM256.341333 650.197333h-34.304v76.373334l34.304-76.373334zM477.013333 199.168H222.037333v379.861333h254.976V199.168z m329.002667 0h-259.072v379.861333h259.072V199.168z\" p-id=\"895\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/edge.svg
// module id = kkMS
// module chunks = 215